
import { setLocalStorage, getLocalStorage } from '@/utils/storage'
const state = {
  current: getLocalStorage('currentApp') || '',
  appName: getLocalStorage('appName') || '',
  materialPointDetail: getLocalStorage('materialPointDetail') || {},
  cardPrintData: getLocalStorage('cardPrintData') || {},
  workHistoryPrintData: getLocalStorage('workHistoryPrintData') || {},
  makinoJumpValue: getLocalStorage('makinoJumpValue') || ''
}

const mutations = {
  SET_APP: (state: any, appCode: string) => {
    state.current = appCode
    setLocalStorage("currentApp", appCode)
  },
  SET_APPNAME: (state: any, appName: string) => {
    state.appName = appName
    setLocalStorage("appName", appName)
  },
  SAVE_MATERIAL_POINT: (state: any, value: any) => {
    state.materialPointDetail = value
    setLocalStorage("materialPointDetail", value)
  },
  SAVE_JOB_POINT: (state: any, value: any) => {
    state.workHistoryPrintData = value
    setLocalStorage("workHistoryPrintData", value)
  },
  SAVE_MAKINO_JUMP: (state: any, value: any) => {
    state.makinoJumpValue = value
    setLocalStorage("makinoJumpValue", value)
  },
}

const actions = {
  setCurrentApp({ commit }: any, appCode: any) {
    commit('SET_APP', appCode)
    commit('permission/SET_ROUTES', [], {root: true})
    commit('user/SET_SETTINGS', appCode, {root: true})
  },
  setAppName({ commit }: any, appName: any) {
    commit('SET_APPNAME', appName)
  },
  saveMaterialPoint({ commit }: any, value: any) {
    commit('SAVE_MATERIAL_POINT', value)
  },
  savejobPoint({ commit }: any, value: any) {
    commit('SAVE_JOB_POINT', value)
  },
  saveMakinoJump({ commit }: any, value: any) {
    commit('SAVE_MAKINO_JUMP', value)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
